import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Manufacturer } from 'src/app/models/manufacturer.model';
import { Model } from 'src/app/models/model.model';
import { Type } from 'src/app/models/type.interface';
import { ManufacturersService } from 'src/app/services/manufacturers/manufacturers.service';
import { ModelsService } from 'src/app/services/models/models.service';

@Component({
  selector: 'app-add-model',
  templateUrl: './add-model.component.html',
  styleUrls: ['./add-model.component.css'],
})
export class AddModelComponent {
  public types: Array<Type> = [
    { Id: 1, TypeName: 'SWRO' },
    { Id: 2, TypeName: 'BWRO' },
  ];
  [x: string]: any;
  constructor(
    private router: Router,
    private modelsService: ModelsService,
    private manufacturersService: ManufacturersService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder
  ) {}

  submitted: boolean = false;
  manufacturers: Manufacturer[] = [];
  AddModelForm!: FormGroup;
  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];
  dateNow: Date = new Date();
  addModelRequest: Model = new Model();
  TypeError: boolean = false;
  ManufacturerIdError: boolean = false;

  ngOnInit(): void {
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if (
      loggedInuserRole.role == 'Standard User' ||
      loggedInuserRole.role == 'Internal User' ||
      loggedInuserRole.role == 'Regional User'
    ) {
      this.logout();
    }
    this.addModelRequest.Type = null;
    this.addModelRequest.ManufacturerId = null;
    this.manufacturersService.getAllManufacturers().subscribe({
      next: (manufacturers) => {
        this.manufacturers = manufacturers;
        
      },
      error: (response) => {
        console.log(response);
      },
    });

    this.AddModelForm = this.formBuilder.group({
      Name: ['', Validators.required],
      Ma: [, Validators.required],
    });
  }


  validation() {
    let isValid = true;

    if (this.addModelRequest.ManufacturerId == null) {
      this.ManufacturerIdError = true;
      isValid = false;
    } else {
      this.ManufacturerIdError = false;
    }

    if (this.addModelRequest.Type == null) {
      this.TypeError = true;
      isValid = false;
    } else {
      this.TypeError = false;
    }

    return isValid;
  }

  addModel() {
    this.submitted = true;
    const dateNowISO = this.dateNow.toISOString();
    const temptype = this.addModelRequest.Type
    const tempManId = this.addModelRequest.ManufacturerId
    const temptcfa = this.addModelRequest.Tcfa
    const temptcfb = this.addModelRequest.Tcfb
    this.addModelRequest.Name = this.AddModelForm.value.Name;
    this.addModelRequest.ManufacturerName = "";
    this.addModelRequest.Ma = Number(this.AddModelForm.value.Ma);
    this.addModelRequest.CreatedAt = dateNowISO;
    this.addModelRequest.UpdatedAt = dateNowISO;
    this.addModelRequest.IsActive = 1;
    this.addModelRequest.Type = Number(temptype);
    this.addModelRequest.ManufacturerId = Number(tempManId);
    this.addModelRequest.Tcfa = temptcfa;
    this.addModelRequest.Tcfb = temptcfb;
    this.validation();
    if (this.AddModelForm.valid && this.validation()) {
      this.modelsService.addModel(this.addModelRequest).subscribe({
        next: (Model) => {
          var id = btoa(Model.Id.toString());
          this.toastr.success(
            'Element Model created successfully.',
            'Information'
          );
          this.router.navigate(['/component/models/edit/' + id]);
        },
        error: (response) => {
          if (response.error.length > 0) {
            this.toastr.error(response.error, 'Error');
          } else {
            this.toastr.error('Error While Creating Element Model.', 'Error');
          }
        },
      });
    } else {
      this.toastr.error('Please validate all fields', 'Error');
    }
    console.log(this.addModelRequest);
  }
  logout() {
    sessionStorage.clear();
    this.router.navigate(['login']);
  }
}
